<div class="page-content">
  <div class="page_header">
    <div class="page_header_text">
      <h1>Rondas</h1>
      <span>Histórico e acompanhamento de rondas</span>
    </div>

    <div class="page_header_actions">
      <button class="btn-web-secondary" (click)="filtrosPainelAberto = true">
        <i class="ri-filter-3-line"></i> Filtros
      </button>
      <button class="btn-web-primary" (click)="criarRonda()">
        <i class="pi pi-plus"></i> Nova Ronda
      </button>
    </div>
  </div>
  <div class="data-table-wrapper">
    <table class="data-table" *ngIf="!loading && rondas.length > 0">
      <thead>
        <tr>
          <th>#</th>
          <th>Posto</th>
          <th>Efetivo</th>
          <th>Início - Termíno</th>
          <th>Turno</th>
          <th>Conformidade</th>
          <th>Acções</th>
        </tr>
      </thead>
      <tbody>
        @for (r of rondas; track r.id) {
          <tr>
            <td class="mono">{{ r.id }}</td>
            <td>{{ r.nomePosto }}</td>
            <td>{{ r.nomeEfetivo }}</td>
            <td>
              {{ r.dataInicio | date: "dd/MM/yyyy HH:mm" }} -
              {{ r.dataFim | date: "dd/MM/yyyy HH:mm" }}
            </td>
            <td>{{ r.nomeTurno }}</td>
            <td>
              <span class="badge" [ngClass]="getConformidadeClass(r)"
                >{{ getConformidade(r) }}%</span
              >
            </td>
            <td class="actions">
              <button
                class="btn-secondary icon-btn"
                (click)="openDetalhe(r)"
                title="Detalhe"
              >
                <i class="fas fa-eye"></i>
              </button>
            </td>
          </tr>
        }
      </tbody>
    </table>
    <app-empty-state
      *ngIf="!loading && rondas.length === 0"
      icon="ri-route-line"
      title="Nenhuma ronda registada"
    ></app-empty-state>
    <div *ngIf="loading" class="skeleton-rows">
      @for (i of [1, 2, 3, 4, 5]; track i) {
        <p-skeleton height="40px" styleClass="mb-2"></p-skeleton>
      }
    </div>

    <p-paginator
      *ngIf="totalRecords > pageSize"
      [rows]="pageSize"
      [totalRecords]="totalRecords"
      [rowsPerPageOptions]="[10, 20, 50]"
      (onPageChange)="onPageChange($event)"
      styleClass="sp-paginator"
    >
    </p-paginator>
  </div>
</div>

<!-- ── DIALOG: Criar ronda ── -->
<p-drawer
  [(visible)]="showNewRonda"
  position="right"
  [modal]="true"
  styleClass="efetivo-drawer-dark"
  [style]="{ width: '460px' }"
  [closable]="true"
>
  <ng-template pTemplate="header">
    <div class="dlg-header">
      <div class="dlg-header-icon"><i class="ri-file-upload-line"></i></div>
      <div>
        <div class="dlg-header-title">Nova Ronda</div>
        <div class="dlg-header-sub">Selecione a escala para criar a ronda</div>
      </div>
    </div>
  </ng-template>

  <div class="dialog-form">
    <div class="form-group">
      <label
        >Seleccion a escala
        <span style="color: var(--sp-danger)">*</span></label
      >
      <p-select
        [options]="escalas"
        [(ngModel)]="escalaId"
        optionLabel="label"
        optionValue="value"
        placeholder="Seleccionar a escala"
        styleClass="w-full"
        appendTo="body"
      />
    </div>
  </div>

  <ng-template pTemplate="footer" class="footer">
    <button class="btn-web-secondary" (click)="showNewRonda = false">
      <i class="fas fa-times"></i> Cancelar
    </button>
    <button class="btn-web-primary" [disabled]="!escalaId" (click)="submitRonda()">
      <i *ngIf="loadNewRonda" class="pi pi-spinner pi-spin"></i>
      <i *ngIf="!loadNewRonda" class="ri-upload-line"></i>
      {{ loadNewRonda ? "A enviar..." : "Guardar" }}
    </button>
  </ng-template>
</p-drawer>

<!-- ── FILTROS OVERLAY ──────────────────────────────────── -->
<div
  class="filtros-overlay"
  [class.open]="filtrosPainelAberto"
  (click)="filtrosPainelAberto = false"
></div>

<!-- ── FILTROS DRAWER ──────────────────────────────────── -->
<div class="filtros-drawer" [class.open]="filtrosPainelAberto">
  <div class="filtros-header">
    <h3><i class="ri-filter-3-line"></i> Filtros</h3>
      <button type="button" (click)="filtrosPainelAberto = false">
      <i class="fas fa-times"></i>
    </button>
  </div>

  <div class="filtros-body" [formGroup]="filtrosForm">
    <div class="filtro-grupo">
      <label>Escala</label>
      <p-select
        formControlName="IdEscala"
        [options]="escalas"
        optionLabel="label"
        optionValue="value"
        placeholder="Seleccione a escala"
        styleClass="w-full"
        appendTo="body"
        [showClear]="true"
      >
      </p-select>
    </div>
    <div class="filtro-grupo">
      <label>Posto</label>
      <p-select
        formControlName="IdPosto"
        [options]="postos"
        optionLabel="label"
        optionValue="value"
        placeholder="Seleccione o posto"
        styleClass="w-full"
        appendTo="body"
        [showClear]="true"
      >
      </p-select>
    </div>
    <div class="filtro-grupo">
      <label>Efetivo</label>
      <p-select
        formControlName="IdEfetivo"
        [options]="efetivos"
        optionLabel="label"
        optionValue="value"
        placeholder="Seleccione o efetivo"
        styleClass="w-full"
        appendTo="body"
        [showClear]="true"
      >
      </p-select>
    </div>
    <div class="filtro-grupo">
      <label>Concluída</label>
      <p-select
        formControlName="Concluida"
        [options]="estadoOptions"
        optionLabel="label"
        optionValue="value"
        placeholder="Seleccione o estado"
        styleClass="w-full"
        appendTo="body"
        [showClear]="true"
      >
      </p-select>
    </div>
    <div class="filtro-grupo">
      <label>Admissão — De</label>
      <p-date-picker
        class="form-input"
        formControlName="DataDe"
        dateFormat="dd/mm/aaa"
      />
    </div>
    <div class="filtro-grupo">
      <label>Admissão — Até</label>
      <p-date-picker
        class="form-input"
        formControlName="DataAte"
        dateFormat="dd/mm/aaa"
      />
    </div>
  </div>

  <div class="filtros-footer">
    <button type="button" class="btn-web-secondary" style="flex: 1" (click)="limparFiltros()">
      <i class="fas fa-undo"></i> Limpar
    </button>
    <button
      type="button"
      class="btn-web-primary"
      style="flex: 2"
      (click)="aplicarFiltrosDrawer()"
    >
      <i class="fas fa-check"></i> Aplicar
    </button>
  </div>
</div>

<app-detalhe-ronda
  [ronda]="ronda"
  [(visible)]="showRendaDetallhe"
></app-detalhe-ronda>
